import React, { useState, useEffect } from 'react';
import MediaModal from './MediaModal';
import { FILE_URL, VIDEO_THUMBNAIL } from '../../constants';
import LazyLoadImage from '../LazyLoadImage';
import { toast } from 'react-toastify';

function MultipleMediaUpload({ name, defaultFiles = [], onChange, authToken }) {
    const [modalShow, setModalShow] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [dragging, setDragging] = useState(false);
    const [draggedIndex, setDraggedIndex] = useState(null);

    // Parse default files if they are provided as a JSON string
    useEffect(() => {
        if (defaultFiles && defaultFiles.length > 0) {
            const parsedFiles = typeof defaultFiles === 'string' ? JSON.parse(defaultFiles) : defaultFiles;
            setSelectedFiles(parsedFiles);
        }
    }, [defaultFiles]);


    const MAX_FILES = 10;
    const handleFileSelect = (files) => {
        const updatedFiles = [...selectedFiles, ...files];
        if (updatedFiles.length > MAX_FILES) {
            toast.error(`You can use a maximum of ${MAX_FILES} files.`);
            return;
        }
        setSelectedFiles(updatedFiles);
        if (onChange) {
            // Notify parent component with updated file list
            const values = JSON.stringify(updatedFiles.map((file) => ({
                id: file.id,
                url: file.file_path || file.url,
                ext: file.ext,
            })));
            onChange(name, values);
        }
    };

    // Handle file removal from selectedFiles
    const handleRemove = (index) => {
        const updatedFiles = selectedFiles.filter((_, i) => i !== index);
        setSelectedFiles(updatedFiles);

        if (onChange) {
            // Notify parent component with updated file list
            const values = JSON.stringify(updatedFiles.map((file) => ({
                id: file.id,
                url: file.file_path || file.url,
                ext: file.ext,
            })));
            onChange(name, values);
        }
    };

    // Handle Drag Start
    const handleDragStart = (e, index) => {
        setDragging(true);
        setDraggedIndex(index);
        e.dataTransfer.effectAllowed = "move";
    };

    // Handle Drag Over (allows dropping)
    const handleDragOver = (e) => {
        e.preventDefault();
    };

    // Handle Drop - Rearranging files
    const handleDrop = (e, index) => {
        e.preventDefault();
        const draggedFile = selectedFiles[draggedIndex];
        const updatedFiles = [...selectedFiles];
        updatedFiles.splice(draggedIndex, 1); // Remove the dragged file
        updatedFiles.splice(index, 0, draggedFile); // Insert it at the new position

        setSelectedFiles(updatedFiles);
        if (onChange) {
            const values = JSON.stringify(updatedFiles.map((file) => ({
                id: file.id,
                url: file.file_path || file.url,
                ext: file.ext,
            })));
            onChange(name, values);
        }
        setDragging(false); // Reset dragging state
    };

    return (
        <div className="gallery-selecter d-block w-100 border p-2 rounded-2 bg-body-secondary">
            <div className="d-flex flex-wrap gap-2">
                {selectedFiles.map((file, index) => {
                    const filePath = file.url || file.file_path; // Use the correct field for the file URL
                    return (
                        <div
                            key={file.id}
                            className="position-relative border bg-body-secondary rounded-2"
                            style={{ width: '100px', aspectRatio: '1' }}
                            draggable
                            onDragStart={(e) => handleDragStart(e, index)}
                            onDragOver={handleDragOver}
                            onDrop={(e) => handleDrop(e, index)}
                        >
                            <LazyLoadImage
                                imgSrc={file.ext == 'mp4' ? VIDEO_THUMBNAIL : `${FILE_URL}${filePath}`}
                                alt={`selected-${index}`}
                                className="w-100 h-100"
                                style={{ objectFit: 'cover' }}
                            />
                            {/* Remove button for each file */}
                            <button
                                type="button"
                                className="btn btn-danger p-0 px-1 rounded-4 position-absolute top-0 end-0 m-1"
                                onClick={() => handleRemove(index)}
                            >
                                <i className="bi bi-x"></i>
                            </button>
                        </div>
                    );
                })}
            </div>

            <div className="upload_dropZone text-center my-2 p-4">
                <button type="button" className="btn btn-upload" onClick={() => setModalShow(true)}>Choose from Gallery</button>
            </div>

            {/* Hidden input for file paths */}
            <input
                type="hidden"
                name={name}
                value={selectedFiles.map((file) => file.file_path || file.url).join(',')}
            />

            {/* Media modal for selecting images from the gallery */}
            {modalShow && (
                <MediaModal
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    onSelectImage={handleFileSelect}
                    mode="multiple"
                    authToken={authToken}
                />
            )}
        </div>
    );
}

export default MultipleMediaUpload;
